import { useCallback, useState } from "react";
import { refreshAccessToken } from "../../../lib/authRefresh";

export function useTokenRefresh() {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refresh = useCallback(async () => {
    // No client-readable refresh token exists — the browser sends the
    // httpOnly refresh cookie automatically. Always attempt; a missing or
    // expired cookie simply comes back as a failed request below.
    setIsRefreshing(true);
    try {
      const accessToken = await refreshAccessToken();
      return accessToken !== null;
    } finally {
      setIsRefreshing(false);
    }
  }, []);

  return { refresh, isRefreshing };
}
